import { Record } from "immutable";
import { Nullable } from "common/records";
import type { IElevationData, ElevationRecord } from "common/records/Elevation";

export const annotationFromJSON = (json: Partial<IAnnotationData>): AnnotationRecord => {
  const recordData: IAnnotationRecord = { ...(json as any) };

  // Strip the nested elevation backref — the API returns IElevationData here,
  // but converting it (and looping back through annotations) would be circular.
  // Callers that need the elevation hydrate it via the elevation reducer instead.
  delete (recordData as any).elevation;

  return new AnnotationRecord(recordData);
};

export interface IAnnotationData {
  id: number;
  guid: string;
  location: string;
  level: string;
  width: number;
  height: number;
  x: number;
  y: number;
  elevation: IElevationData;
  opening_type: string;
  opening_id: number;
  sort_order?: number;
}

export interface IAnnotationRecord {
  id: number;
  guid: string;
  location: string;
  level: string;
  width: number;
  height: number;
  x: number;
  y: number;
  elevation: Nullable<ElevationRecord>;
  opening_type: string;
  opening_id: number;
  sort_order: Nullable<number>;
}

const defaultAnnotationProps: IAnnotationRecord = {
  id: 0,
  guid: "",
  location: "",
  level: "",
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  elevation: null,
  opening_type: "window",
  opening_id: 0,
  sort_order: null,
};

export class AnnotationRecord extends Record(defaultAnnotationProps) implements IAnnotationRecord {}
